import React from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/Card';
import { Flame, Leaf, Heart, Droplet, Sparkles } from 'lucide-react';
export function HealingIngredients() {
  const ingredients = [{
    icon: <Sparkles className="w-8 h-8 text-[#D4A017]" data-id="element-14" />,
    name: 'Cúrcuma',
    desc: "El 'Ibuprofeno natural'. Úsalo siempre con pimienta negra para activar su poder."
  }, {
    icon: <Flame className="w-8 h-8 text-[#C67B5C]" data-id="element-15" />,
    name: 'Jengibre Fresco',
    desc: "Apaga el 'fuego' inflamatorio de tu estómago y mejora la digestión nocturna."
  }, {
    icon: <Heart className="w-8 h-8 text-[#5C3D2E]" data-id="element-16" />,
    name: 'Ajo',
    desc: 'Tu mejor aliado para limpiar las arterias, proteger tu corazón y dar un sabor increíble.'
  }, {
    icon: <Droplet className="w-8 h-8 text-[#D4A017]" data-id="element-17" />,
    name: 'Aceite de Oliva Extra Virgen',
    desc: 'El lubricante natural perfecto para tus rodillas y articulaciones rígidas.'
  }, {
    icon: <Leaf className="w-8 h-8 text-[#5B7A3A]" data-id="element-18" />,
    name: 'Cilantro y Perejil',
    desc: 'Ayudan a tus riñones a eliminar el exceso de agua y toxinas acumuladas.'
  }];
  return <section className="py-20 px-4 bg-[#5B7A3A] text-white relative overflow-hidden" data-id="element-19">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-20">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg" data-id="element-21">
          <defs data-id="element-22">
            <pattern id="leaf-pattern" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse" data-id="element-23">
              <path d="M50 15c-15 0-25 15-25 35s10 35 25 35 25-15 25-35-10-35-25-35zm0 60c-10 0-15-10-15-25s5-25 15-25 15 10 15 25-5 25-15 25z" fill="currentColor" data-id="element-24" />
            </pattern>
          </defs>
          <rect x="0" y="0" width="100%" height="100%" fill="url(#leaf-pattern)" data-id="element-25" />
        </svg>
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-27">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[#FFFDF5]" data-id="element-28">
            La Alacena Curativa: Tus 5 Soldados
          </h2>
          <p className="text-xl max-w-3xl mx-auto text-[#FFF8E7]" data-id="element-29">
            Antes de cocinar, asegúrate de tener estos ingredientes en tu
            cocina. Son fáciles de encontrar en tu Walmart, Aldi o Publix más
            cercano.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-30">
          {ingredients.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#FFFDF5] rounded-2xl p-6 shadow-lg flex flex-col items-center text-center transform transition hover:-translate-y-1" data-id="element-31">
              <div className="w-16 h-16 rounded-full bg-[#FFF8E7] flex items-center justify-center mb-4 border-2 border-[#D4A017]/30" data-id="element-32">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-[#5C3D2E] mb-3" data-id="element-33">
                {item.name}
              </h3>
              <p className="text-[#5C3D2E] opacity-90" data-id="element-34">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}